import request from "@/utils/request";

//课题申报
export const  signTopic =(data) =>{
    return request({
        url: "/businessservice/topicSign/create",
        method:"post",
        data: data
    })
}

//删除课题文件
export const  deleteTopicFile =(query) =>{
    return request({
        url: "/businessservice/topicFile/deleteFile",
        method:"get",
        params: query
    })
}

//提交课题资料
export const  handleTopicFile =(data) =>{
    return request({
        url: "/businessservice/topicSign/handleFile",
        method:"post",
        data: data
    })
}

//分页查询
export const  pageTopicSign =(data) =>{
    return request({
        url: "/businessservice/topicSign/page",
        method:"post",
        data: data
    })
}

//分配审核人
export const  divideCheckUser =(data) =>{
    return request({
        url: "/businessservice/topicSign/divideCheckUser",
        method:"post",
        data: data
    })
}

//查询申报信息详情
export const  infoTopicSign =(query) =>{
    return request({
        url: "/businessservice/topicSign/info",
        method:"get",
        params: query
    })
}

//审核申报信息
export const  checkTopicSign =(data) =>{
    return request({
        url: "/businessservice/topicSign/check",
        method:"post",
        data: data
    })
}

//查询用户审核课题申报列表
export const  userCheckSignList =(query) =>{
    return request({
        url: "/businessservice/topicSign/userCheckList",
        method:"get",
        params: query
    })
}